var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,29A14.5,14.5,0,1,0,0,14.5,14.51,14.51,0,0,0,14.5,29Zm0-28A13.5,13.5,0,1,1,1,14.5,13.52,13.52,0,0,1,14.5,1ZM8,14.81a.5.5,0,0,1,.5-.5H19.26l-4.11-4a.5.5,0,0,1,.35-.86.54.54,0,0,1,.35.14l5,4.81h0a.6.6,0,0,1,.09.13l0,0s0,0,0,.05a.58.58,0,0,1,0,.14h0s0,0,0,.07A.35.35,0,0,1,21,15a.29.29,0,0,1-.07.12l0,0h0l-4.49,4.69a.5.5,0,1,1-.72-.7l3.69-3.84H8.5A.5.5,0,0,1,8,14.81Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightO);
export default __webpack_public_path__ + "static/media/arrow-right-o.bb37d7662e5ad1fd345499147bd8f431.svg";
export { ForwardRef as ReactComponent };